<div class="flex w-full items-center justify-center min-h-[170px] gap-4 tprm-donut-chart-shell" [class.tprm-donut-empty]="isNoData">
  <div
    *ngIf="isNoData"
    class="flex flex-col items-center justify-center w-full min-h-[150px] rounded-2xl border border-slate-200 bg-slate-50/80 px-4 py-5 text-center tprm-donut-empty-state"
  >
    <div class="mb-2 flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white text-[9px] font-black uppercase tracking-[0.14em] text-slate-400">No data</div>
    <div class="text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500">No dashboard data</div>
    <div class="mt-1 max-w-[220px] text-[12px] font-medium leading-snug text-slate-600">
      Seed or API data is required before this risk split can be reviewed.
    </div>
  </div>

  <ng-container *ngIf="!isNoData">
    <apx-chart
      *ngIf="chartOptions"
      class="flex min-w-[150px] w-[52%] max-w-[220px] h-[150px] items-center justify-center tprm-balanced-donut-chart"
      [chart]="chartOptions.chart"
      [colors]="chartOptions.colors"
      [labels]="chartOptions.labels"
      [plotOptions]="chartOptions.plotOptions"
      [series]="chartOptions.series"
      [states]="chartOptions.states"
      [tooltip]="chartOptions.tooltip"
      [stroke]="chartOptions.stroke"
    ></apx-chart>

    <div
      class="flex min-w-[128px] flex-grow items-center justify-center text-xs font-bold tprm-donut-legend"
      role="region"
      aria-label="Risk Level Statistics"
    >
      <div class="w-full max-w-[178px]">
        <div
          *ngFor="let item of formattedData; let i = index"
          class="mb-2 flex w-full justify-between gap-2"
        >
          <div class="flex min-w-0 items-center gap-2 text-neutral-600">
            <div
              class="my-auto flex h-[11px] w-[11px] shrink-0 rounded-full"
              [style.background-color]="item.color"
            ></div>
            <div
              class="truncate text-[11px] text-[#000] transition cursor-pointer hover:drop-shadow-md"
              (click)="onChartClick(item.label, i)"
            >
              {{ item.label }}
            </div>
          </div>
          <div [style.color]="item.color" class="text-[11px] font-extrabold">
            {{ item.count }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
